import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const slides = ['https://cdn.magicpatterns.com/uploads/4HcQGmcgC2ERHzfLcGgTf1/Screenshot_2026-06-16_at_11.15.50_PM.png', 'https://cdn.magicpatterns.com/uploads/2VKThjASMqWGqjSBi9qQSe/Screenshot_2026-06-16_at_11.16.03_PM.png', 'https://cdn.magicpatterns.com/uploads/9wmcQFaU16tNPt6zDHuduo/Screenshot_2026-06-16_at_11.17.43_PM.png'];
const scrollToCheckout = () => {
  document.getElementById('compra')?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function ContentPreview() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % slides.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
  };
  return <section className="w-full bg-blue-50 py-12 md:py-16 px-4" data-id="element-32">
      <div className="max-w-5xl mx-auto" data-id="element-33">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-34">
          Un vistazo sobre el contenido
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative max-w-3xl mx-auto" data-id="element-35">
          <div className="relative aspect-[4/3] bg-gray-100 rounded-lg overflow-hidden shadow-2xl" data-id="element-36">
            <AnimatePresence mode="wait" data-id="element-37">
              <motion.img key={currentSlide} src={slides[currentSlide]} alt={`Contenido preview ${currentSlide + 1}`} initial={{
              opacity: 0,
              x: 100
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -100
            }} transition={{
              duration: 0.5
            }} className="w-full h-full object-cover cursor-pointer" onClick={scrollToCheckout} data-id="element-38" />
            </AnimatePresence>

            <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-3 rounded-full shadow-lg transition-all hover:scale-110" aria-label="Anterior" data-id="element-39">
              <ChevronLeftIcon className="w-6 h-6 text-gray-800" data-id="element-40" />
            </button>

            <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-3 rounded-full shadow-lg transition-all hover:scale-110" aria-label="Siguiente" data-id="element-41">
              <ChevronRightIcon className="w-6 h-6 text-gray-800" data-id="element-42" />
            </button>
          </div>

          <div className="flex justify-center gap-2 mt-6" data-id="element-43">
            {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-3 h-3 rounded-full transition-all ${currentSlide === index ? 'bg-orange-500 w-8' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a slide ${index + 1}`} data-id="element-44" />)}
          </div>
        </motion.div>
      </div>
    </section>;
}